// en/views/channelOta.js
export const channelOta = {
  common: {
    listing: "Anúncio",
    back: "Voltar",
    close: "Fechar",
    cancel: "Cancelar",
    flexible: "Flexível",
    noResults: "Nenhum resultado",
    deleteConn: "Excluir conexão",
  },
  head: {
    manage: "Gerenciar {channel}",
    airbnbConfig: "Configurações do Airbnb",
    channelOptions: "Opções do canal",
  },
  picker: {
    placeholder: "Busque ou selecione um anúncio…",
  },
  loading: {
    status: "Carregando status do canal…",
    listings: "Carregando seus anúncios do Airbnb…",
    settings: "Carregando configurações do anúncio…",
  },
  accounts: {
    title: "Para qual das suas contas da {channel}?",
    lead: "Você já tem uma conta da {channel} conectada. Pode adicionar este anúncio a ela ou conectar outra conta. | Você já tem {n} contas da {channel} conectadas. Escolha a qual este anúncio pertence, ou conecte outra.",
    account: "Conta {n}",
    empty: "Ainda sem anúncios",
    andMore: "{list} e mais {rest}",
    newTitle: "Conectar outra conta da {channel}",
    newDesc: "Para anúncios que estão em outra conta",
  },
  confirm: {
    title: "Excluir conexão do {channel}",
    desc: "O canal será removido do gerenciador de canais e das suas conexões ativas.",
    coversPre: "Esta conexão cobre ",
    coversCount: "{count} anúncio | {count} anúncios",
    coversPost: " e será desconectada de todos eles: {list}",
    purgePre: "Excluir também as reservas importadas? Escolha quais quartos ",
    purgeNote: "(podem ser recuperadas)",
    selectAll: "Todos",
    unselectAll: "Limpar tudo",
    delete: "Excluir",
    detachOnly: "Desconectar apenas este anúncio",
    deleteAll: "Excluir e desconectar {count} anúncio | Excluir e desconectar os {count} anúncios",
    deleteWithResv: "Excluir (+{count} reserva) | Excluir (+{count} reservas)",
  },
  gone: {
    title: "Esta conexão não existe mais no canal",
    desc: "O canal foi excluído no gerenciador de canais. Exclua esta conexão para reconectá-la em “Conectar agora”.",
  },
  menu: {
    channelOptDesc: "Ative ou pause, edite o mapeamento, sincronize, importe reservas ou exclua a conexão.",
    airbnbCfgDesc: "Horários de check-in/out, antecedência, preços e limpeza de cada anúncio.",
  },
  channel: {
    statusLabel: "Status do canal",
    active: "Ativo",
    inactive: "Inativo",
    deactivate: "Desativar canal",
    activate: "Ativar canal",
    pending: "Em revisão",
    hintPending: "O canal está ligado e já tem os seus dados. Falta o canal rever e aceitar o seu alojamento; quando o fizer, ativa-se sozinho. Costuma demorar alguns dias. Se demorar mais, escreva-nos e verificamos.",
    hintActive: "O canal está ativo: enviamos preços e disponibilidade. Desative-o para pausar o envio sem perder o mapeamento.",
    blockersTitle: "Falta algo para o canal ser ativado",
    blockersHint: "Carregue novamente em “Ligar” no assistente e nós corrigimos e reenviamos.",
    hintInactive: "O canal está conectado, mas pausado. Ative-o para começar a enviar preços e disponibilidade.",
    editTitle: "Editar canal",
    editDesc: "Altere ou adicione quartos e planos de tarifas mapeados para este canal.",
    editBtn: "Editar mapeamento",
    fullSyncTitle: "Sincronização completa",
    fullSyncDesc: "Reenvia todos os preços, disponibilidade e restrições ao canal.",
    synced: "Sincronizado",
    sync: "Sincronizar",
    extractTitle: "Importar reservas futuras",
    extractDesc: "Importe para a WACheckin as reservas que você já tem no canal.",
    imported: "Importadas",
    extract: "Importar",
    resyncTitle: "Reimportar reservas",
    resyncDesc: "Busque novamente todas as reservas do canal e reatribua-as com o mapeamento atual. Use se você selecionou o anúncio errado ou se faltam reservas.",
    resync: "Reimportar",
  },
  cfg: {
    emptyNoListings: "Você ainda não vinculou nenhum anúncio. Acesse <b>Opções do canal → Editar mapeamento</b> para conectar seus anúncios do Airbnb às suas unidades.",
    emptyNoMapping: "Esta propriedade ainda não tem nenhum anúncio do Airbnb vinculado. Acesse <b>Opções do canal → Editar mapeamento</b> e vincule o anúncio para definir os horários e preços aqui.",
  },
  arrival: {
    section: "Chegada e saída",
    lead: "Em quais horários e dias seus hóspedes podem fazer check-in e check-out.",
    checkInFrom: "Check-in a partir de",
    checkInFromTip: "Horário mais cedo em que um hóspede pode fazer check-in.",
    checkInTo: "Check-in até",
    checkInToTip: "Horário mais tarde em que um hóspede pode chegar.",
    checkOut: "Check-out",
    checkOutTip: "Horário limite para o hóspede deixar a propriedade.",
    unset: "Não definido",
    daysIn: "Dias em que o check-in é permitido",
    daysInTip: "Dias da semana em que um hóspede pode fazer check-in.",
    daysOut: "Dias em que o check-out é permitido",
    daysOutTip: "Dias da semana em que um hóspede pode fazer check-out.",
  },
  booking: {
    section: "Reservas",
    window: "Janela de disponibilidade",
    windowTip: "Com quanta antecedência seu calendário fica disponível para venda. É o que o Airbnb chama de 'janela de disponibilidade' (12 meses = 365 dias). NÃO é o máximo de noites por estadia.",
    minLead: "Antecedência mínima",
    minLeadTip: "Com quanta antecedência antes da chegada uma reserva pode ser feita. Evita reservas de última hora.",
    maxStay: "Estadia máxima",
    maxStayTip: "Número máximo de noites por reserva. É o 'máximo de noites' do Airbnb, diferente da janela de disponibilidade.",
    turnover: "Dias entre reservas",
    turnoverTip: "Dias bloqueados entre um check-out e o próximo check-in, para limpar e preparar.",
  },
  rules: {
    section: "Regras de reserva",
    cancelPolicy: "Política de cancelamento",
    cancelPolicyTip: "Quanto o hóspede pode recuperar se cancelar. Flexível = mais tolerante; Rígida = menos reembolso.",
    whoCanBook: "Quem pode reservar",
    whoCanBookTip: "Quem pode reservar instantaneamente sem a sua aprovação prévia.",
  },
  prices: {
    section: "Preços",
    perNight: "Preço por noite",
    weekend: "Preço de fim de semana",
    weekendTip: "Preço para sexta e sábado. Deixe igual ao preço por noite se não quiser diferença.",
    guestsIncluded: "Hóspedes incluídos",
    guestsIncludedTip: "Número de hóspedes sem custo adicional.",
    extraGuest: "Preço por hóspede adicional",
    extraGuestTip: "Custo por hóspede adicional, por noite, além dos incluídos.",
  },
  cleaning: {
    section: "Limpeza",
    notePre: "Preencha os dois para que toda reserva pague pela limpeza. A taxa de estadia longa deve ser ",
    noteStrong: "igual ou maior",
    notePost: " que a de estadia curta. Se deixar uma em 0, esse tipo de estadia não pagará pela limpeza.",
    long: "Limpeza · estadia longa",
    longTip: "Cobrada em estadias longas. Deve ser igual ou maior que a taxa de estadia curta.",
    short: "Limpeza · estadia curta",
    shortTip: "Cobrada em estadias curtas (poucas noites).",
    error: "A taxa de limpeza de estadia longa ({sym}{long}) deve ser igual ou maior que a de estadia curta ({sym}{short}).",
  },
  tax: {
    section: "Taxa turística",
    lead: "Imposto local que você cobra do hóspede e declara por conta própria (não o Airbnb). Deixe em 0 se não se aplicar.",
    amount: "Valor",
    amountTip: "Valor do imposto. Defina 0 para não aplicá-lo.",
    charged: "Cobrado",
    chargedTip: "Como o imposto é calculado: por hóspede por noite, por noite ou por hóspede.",
    perGuestNight: "Por hóspede por noite",
    perNight: "Por noite",
    perGuest: "Por hóspede",
    attestation: "Confirmo que estas informações estão corretas e que assumo a responsabilidade por cobrar e declarar este imposto.",
  },
  footer: {
    save: "Salvar configurações",
    saving: "Salvando…",
  },
  opts: {
    noticeNoLimit: "Sem limite (todas as datas)",
    months: "{count} mês | {count} meses",
    maxNoLimit: "Sem limite",
    nights: "{count} noite | {count} noites",
    maxNights: "Máximo ({count})",
    cancelModerate: "Moderada",
    cancelFirm: "Firme",
    cancelStrict: "Rígida",
    instantEveryone: "Qualquer hóspede",
    instantWellReviewed: "Hóspedes bem avaliados",
    instantVerified: "Identidade verificada",
    instantReviewedVerified: "Avaliações + identidade",
    leadNone: "Sem antecedência",
    hours: "{count} hora | {count} horas",
    days: "{count} dia | {count} dias",
  },
  msg: {
    loadSettingsError: "Não foi possível carregar as configurações do anúncio.",
    taxAttestationWarn: "Marque a caixa de confirmação para aplicar a taxa turística.",
    saveOk: "Configurações do Airbnb salvas e enviadas ao canal.",
    saveError: "Não foi possível salvar as configurações.",
    statusError: "Não foi possível carregar o status do canal.",
    activated: "Canal ativado.",
    deactivated: "Canal desativado.",
    toggleError: "Não foi possível alterar o status do canal.",
    resyncOk: "Reservas reimportadas: {imported}.",
    resyncOkWarn: "Reservas reimportadas: {imported} ({errors} com aviso).",
    resyncError: "Não foi possível reimportar as reservas.",
    disconnectError: "Não foi possível excluir a conexão.",
    fullSyncOk: "Sincronização completa enviada.",
    extractOk: "Reservas futuras importadas.",
    actionError: "Não foi possível executar a ação.",
  },
  rate: {
    apply: "Aplicar",
    or: "ou",
    usePlan: "use uma das suas tarifas…",
  },
};